import React, { useId } from 'react';
import PropTypes from 'prop-types';
import invariant from 'tiny-invariant';
import styles from './FormField.less';
import { z } from 'zod';

export function FormField({
  type,
  label,
  value,
  onChange,
  required = false,
  ...rest
}) {
  invariant(type === 'text');
  const id = useId();
  return (
    <div className={styles.container}>
      <label className={styles.label} htmlFor={id}>
        {label} {required && <span className={styles.asterisk}>*</span>}
      </label>
      <input
        id={id}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        {...InputProps.parse(rest)}
      />
    </div>
  );
}

const InputProps = z
  .strictObject({
    autoFocus: z.boolean(),
    maxLength: z.number(),
    minLength: z.number(),
  })
  .partial();

FormField.propTypes = {
  label: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text']),
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
};
